__turbopack_context__.v({
  "carousel": "pmxDRG_carousel",
  "carouselItem": "pmxDRG_carouselItem",
  "carouselItems": "pmxDRG_carouselItems",
  "content": "pmxDRG_content",
  "description": "pmxDRG_description",
  "head": "pmxDRG_head",
  "imgContainer": "pmxDRG_imgContainer",
  "label": "pmxDRG_label",
  "marquee": "pmxDRG_marquee",
  "root": "pmxDRG_root",
  "tag": "pmxDRG_tag",
});
